import { Logo, SocialIcons } from "./components/graphics/icons";
import { HomePage } from "./components/pages/home";
import { PrivacyPolicy } from "./components/pages/privacy";
import { NavBar } from "./components/UI/navbar";
import { Route, Router } from "wouter";

function App() {
  return (
    <Router>
      <NavBar />
      <Route path="/" component={HomePage} />
      <Route path="/privacy" component={PrivacyPolicy} />
      <footer>
        <div className="footer-links hide">
          <div />
          <a href="mailto:info@the-agency.live">info@the-agency.live</a>
          <div />
        </div>
        <div className="footer-logo">
          <Logo />
        </div>
        <div className="footer-links">
          <div />
          <a className="hide" href="/privacy">
            Privacy Policy
          </a>
          <SocialIcons />
        </div>
      </footer>
    </Router>
  );
}

export default App;
